// What an exam calculator form shows (JLPT, EJU). ⛔ Display only: the server reads the
// way the reader chose and computes everything from what is submitted.

// A group of fields belongs to one way in: a level for a reader who has never
// sat the exam, a score report for one who has.
export function showsWay(group, chosen) {
  return group === chosen
}

// A score field names the levels that score its section. Until a level is
// chosen every field stays, each labelled with its section.
export function showsScoreField(levels, target) {
  if (!target) return true
  return levels.split(/\s+/).includes(target)
}
